<template>
	<div class="fragebogen">
		<v-dialog v-model="instruktion" persistent max-width="800">
			<v-card>
				<v-card-title>Hinweise zur Bearbeitung des Fragebogens</v-card-title>
				<v-card-text>
					<ul>
						<li>Bitte nehmen Sie sich ausreichend Zeit für die Bearbeitung des Fragebogens. Die Bearbeitung dauert ca. 10 min. Sie sollten während dieser Zeit ungestört sein sowie die Bearbeitung nicht unterbrechen.</li>
						<li>Bitte lesen Sie sich alle Informationen aufmerksam durch. Es gibt keine "richtigen" oder "falschen" Antworten, da es bei dieser Befragung ausschließlich um Ihre persönliche Meinung geht.</li>
						<li>Bitte beantworten Sie möglichst alle Fragen. Sollte Ihnen die Antwort einmal schwer fallen, so entscheiden Sie sich für die Antwortmöglichkeit, die am ehesten zutreffen könnte.</li>
					</ul>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="instruktion=false">Weiter</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- <p style="display:block;">{{seiten}} / {{seiten.length}} / {{seite}} / {{seiten[seite]}}</p> -->
		<!-- <p><v-select :items="skalen" label="Fragebogen" v-model="fragebogen" @change="fragebogenHolen()"></v-select></p> -->
		<demographie v-if="seiten[seite]=='demographie'" @demographieAntwort="demographieAntwortHinterlegen($event)"></demographie>
		<div v-else>
			<itembatterie :fragebogen="fragebogen" :key="fragebogen" darstellung="1" @fragebogenAntwort="fragebogenAntwortHinterlegen($event)"></itembatterie>
			<!-- <itembatterie :fragebogen="fragebogen" :key="fragebogen" darstellung="1" v-if="$vuetify.breakpoint.mdAndUp==true" @fragebogenAntwort="fragebogenAntwortHinterlegen($event)"></itembatterie>
			<einzelitems :fragebogen="fragebogen" v-else></einzelitems> -->
		</div>
		<div style="margin-top:2em;text-align:center;"><v-btn v-on:click="fragebogenWeiter()">Weiter</v-btn></div>
	</div>
</template>
<script>
	import axios from 'axios';
	import itembatterie from '../components/itembatterie.vue'
	// import einzelitems from '../components/einzelitems.vue'
	import demographie from '../components/demographie.vue'	
	export default {
		name: 'fragebogen',
		components: {
			itembatterie,
			// einzelitems,
			demographie
		},
		data: function () {
			return {
				fragebogenSeiten: String,
				gruppe: String,
				instruktion: true,
				fragebogen: null,
				skalen: [],
				seiten: [],
				seite: 0,
				fragebogenAntworten: {},
				demographieAntworten: {}
			}
		},
		methods: {
			skalenAbfragen: function() {
				axios.get('https://www.arbeitsverdichtung.de/api/skalenabfrage')
				.then(response => {
					this.skalen = response.data;
					console.log('Skalenabfrage');
					console.log(this.skalen);
				})
				.catch(error => {
					this.errorMessage = error.message;
					console.error("There was an error!", error);
				});
			},
			fragebogenAntwortHinterlegen: function(value) {
				this.fragebogenAntworten[value['item']] = value['antwort'];
				console.log('fragebogen.vue');
				console.log(this.fragebogenAntworten);
			},
			demographieAntwortHinterlegen: function(value) {
				this.demographieAntworten[value['item']] = value['antwort'];
				console.log('fragebogen.vue');
				console.log(this.demographieAntworten);
			},				
			fragebogenWeiter: function() {
				if (this.seiten[this.seite]=='demographie') {
					axios.post('https://www.arbeitsverdichtung.de/api/demographie', {
						teilnehmer: this.teilnehmer,
						gruppe: this.gruppe,
						demographieAntworten: this.demographieAntworten
					})
					.then(response => {
						console.log(response);
						this.$router.push({path: '/auswertung'});
					})
					.catch(error => {
						console.log(error);
					});
				} else {
					axios.post('https://www.arbeitsverdichtung.de/api/fragebogen', {
						teilnehmer: this.teilnehmer,
						erhebung: '1',
						fragebogenAntworten: this.fragebogenAntworten
					})
					.then(response => {
						console.log(response);
						// this.$router.push({path: '/auswertung'});
						if (this.seite < this.seiten.length) {
							this.seite += 1;
							console.log(this.seite+' / '+this.seiten.length);
							this.fragebogen = this.seiten[this.seite];
						} else {
							console.log('Fertig!');
							this.fragebogen="demographie";
						}
					})
					.catch(error => {
						console.log(error);
					});
				}
			}
		},
		computed: {
			teilnehmer() {
				return this.$store.state.teilnehmer;
			}
		},
		mounted() {
			/* Falls ein Fragebogen gesetzt, ist dann werden die angeforderten Seiten weitergereicht */
			// console.log(this.$route.query);
			// if (this.$route.query) {
			// 	/* Aufruf eines Fragebogens */
			// 	if (this.$route.query.e) {
			// 		console.log(this.$route.query.e);
			// 		this.$router.push({name: 'Registrierung', params: {fragebogenSeiten: JSON.stringify(this.$route.query.e)}});
			// 	}
			// }
			console.log('Fragebogen ############');
			console.log('Parameter e: ' + this.$route.query.e);
			console.log('Parameter b: ' + this.$route.query.b);
			this.fragebogenSeiten = this.$route.query.e;
			this.gruppe = this.$route.query.b;
			/* Abfrage aller vorhandenenen Skalen */
			this.skalenAbfragen();
			// console.log(this.fragebogenSeiten);
			// console.log(JSON.parse(this.fragebogenSeiten));
			/* Fragebogen anzeigen */
			if (this.fragebogenSeiten) {
				// this.seiten = JSON.parse(this.fragebogenSeiten);
				// this.seiten.push(this.fragebogenSeiten);
				this.seiten = ["avki","demographie"];
				console.log(this.seiten);
				console.log(this.seiten[this.seite]);
				this.fragebogen = this.seiten[this.seite];
			/* Rückfalloption, falls keine Seien über den Query String angefragt wurden */
			} else {
				this.seiten = ["avki","demographie"];
				this.fragebogen = this.seiten[this.seite];
			}
		}
	}
</script>
